
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"59","height":"66","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M58.316 53.88V5.026A5.025 5.025 0 0052.298.101L17.454 5.703c.301.717.407 1.525.31 2.3l34.982-5.627a2.706 2.706 0 013.245 2.65V15.66L20.08 22.934l-.31-17.28c-.375.114-.79.18-1.239.18-.391 0-.742-.05-1.076-.131l.31 31.786A10.033 10.033 0 005.05 35.2C.818 37.611-1.057 42.724.598 47.315c1.656 4.583 6.377 7.314 11.18 6.474a10.028 10.028 0 008.301-9.891V25.307l35.913-7.274v30.612a10.064 10.064 0 00-13.031-2.006 10.065 10.065 0 00-3.857 12.607 10.08 10.08 0 0011.922 5.635 10.1 10.1 0 007.29-11zm-48.283-2.259a7.731 7.731 0 117.73-7.73 7.747 7.747 0 01-7.73 7.73zM48.35 62.866a7.72 7.72 0 01-7.714-7.355c-.204-4.118 2.87-7.665 6.972-8.065A7.726 7.726 0 0156 54.02v.954c0 .139.025.277.074.408-.14 4.175-3.556 7.485-7.723 7.485z","fill":"#C4C2DC"}})])
          )
        }
      }
    